module.exports = __webpack_public_path__ + "static/Hero-Onsite-Clinics-min-8ac3bba2779d16f3ab605810f4eee595.png";